import React from "react";
import { DISPLAY_CURRENCIES } from "common/constants";
import styled from "styled-components";
import { BTC } from "common/Icons/Icons";
import { useDispatch, useSelector } from "react-redux";
import {
  commonActions,
  selectDisplayCurrency,
} from "@shared/slices/common.slice";
import { HEADER_ICON_SIZE } from "@shared/common/Themes/constants";

const DisplayCurrencyToggle = ({ style }) => {
  const dispatch = useDispatch();
  const currencies = Object.keys(DISPLAY_CURRENCIES);
  const displayCurrency = useSelector(selectDisplayCurrency);

  const handleClick = () => {
    const nextIndex =
      (currencies.indexOf(displayCurrency) + 1) % currencies.length;
    dispatch(commonActions.setDisplayCurrency(currencies[nextIndex]));
  };

  return (
    <Wrapper onClick={handleClick} style={style}>
      {displayCurrency === DISPLAY_CURRENCIES.BTC ? (
        <BTC />
      ) : (
        <Dollar>$</Dollar>
      )}
    </Wrapper>
  );
};

export default DisplayCurrencyToggle;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  width: 20px;
  font-size: ${HEADER_ICON_SIZE};
`;

const Dollar = styled.div`
  margin-bottom: 2px;
`;
